import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import { Col, Row } from 'react-bootstrap';
import { USDollar } from '/src/utilities/formats';
import NoData from '../NoData';
import IconDebt from '~/src/images/widgets/student-access-earnings-classification/icon-debt.svg';

export default function ScorecardData({ institutionData }) {

    if (!institutionData.scorecard.id) {
        return <NoData widgetTitle={'Price, Earnings, Financial Aid, and Debt'} />;
    }


    const earnings = institutionData.post_meta.sae_2025_earnings.value;
    const compearnings = institutionData.post_meta.sae_2025_compearn.value;

    const receivedLoans = institutionData.scorecard.debt.received_loans;
    const meanDebt = institutionData.scorecard.debt.average_debt;

    const net_price = institutionData.scorecard.net_price;

    return (
        <Widget className="earnings-outcomes">
            <Row gap={5} gap-lg={0} className="mb-2">
                <Col>
                    <WidgetTitle>Net Price</WidgetTitle>
                    <div className="d-flex justify-content-between align-items-end">
                        <p><strong>Average Annual Cost:</strong></p>
                        <p className="data-point-large"><strong>{USDollar.format(net_price.value)}</strong></p>
                    </div>
                </Col>
            </Row>
            <Row gap={5} gap-lg={0} className="mb-2">
                <Col>
                    <WidgetTitle className="d-flex align-items-center">
                        <img src='/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/student-access-earnings-classification/icon-earnings.svg'
                            role="presentation" width="33" height="29" className="me-2" />
                        Earnings Outcomes
                    </WidgetTitle>

                    <div className="d-flex justify-content-between align-items-end">
                        <p className="mb-2">Median Earnings:</p>
                        <p className="mb-2 data-point-large"><strong>{USDollar.format(earnings)}</strong></p>
                    </div>
                    <div className="d-flex justify-content-between align-items-end">
                        <p>Comparison Earnings:</p>
                        <p>{USDollar.format(compearnings)}</p>
                    </div>
                </Col>
            </Row>
            <Row gap={5} gap-lg={0}>
                <Col>
                    <WidgetTitle className="d-flex align-items-center">
                        <img src='/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/student-access-earnings-classification/icon-debt.svg'
                            role="presentation" width="32" height="26" className="me-2" />
                        Financial Aid and Debt
                    </WidgetTitle>
                    <div className="d-flex justify-content-between align-items-end">
                        <p className="mb-2">Median Debt:</p>
                        {meanDebt ?
                            <p className="data-point-large mb-2"><strong>{USDollar.format(meanDebt)}</strong></p>
                            : <p className="data-point-large mb-2"><strong>--</strong></p>
                        }
                    </div>
                    <div className="d-flex justify-content-between align-items-end">
                        <p>Students Receive Federal Loans: </p>
                        <p>{(receivedLoans * 100).toFixed(0)}%</p>
                    </div>
                </Col>
            </Row>
        </Widget >
    );
}